import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { _isPersonId, AuthService } from 'app/services/auth.service';
import { CategoryService } from 'app/services/models/category.service';
import { NoteService } from 'app/services/models/note.service';
import { PersonService } from 'app/services/models/person.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';
import { CreateCategoryDialogComponent } from '../create-category-dialog/create-category-dialog.component';

@Component({
  selector: 'app-note-dialog',
  templateUrl: './note-dialog.component.html',
  styleUrls: ['./note-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NoteDialogComponent implements OnInit {
  @Input() id?: number;

  date = new Date();

  public dateTimeOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: false,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
  };

  noteForm: FormGroup;
  categories: any[] = [];
  personReceviers: any[] = [];
  personSenders: any[] = [];
  loading = false;

  constructor(
    private fb: FormBuilder,
    private categoryService: CategoryService,
    public activeModal: NgbActiveModal,
    private personService: PersonService,
    private noteService: NoteService,
    private toastrService: ToastrService,
    private modalService: NgbModal,
    public authService: AuthService) { }

  async ngOnInit() {
    const today = new Date();

    this.noteForm = this.fb.group({
      categoryId: [null, Validators.required],
      description: [null, [Validators.required, Validators.minLength(3)]],
      personRecevierId: [null],
      createdAt: [today]
    });
    await this.getAllCategories();
    await this.getAllPersonReceviers();
    if (this.id != null) {
      await this.getByIdNote(this.id);
    }
  }

  async getAllCategories() {
    const data = await this.categoryService.getAllCategory(0, 100, '', 3022);
    console.log(data);
    this.categories = data.categories;
  }

  async getAllPersonReceviers() {
    const data = await this.personService.getByIdCompanyPersons(1);
    this.personReceviers = data.map(p => ({
      ...p,
      fullName: `${p.name} ${p.lastName}`
    }));
  }

  async getByIdNote(id) {
    const data = await this.noteService.getByIdNote(id);
    console.log(data);
    if (data.personRecevierId != null)
      await this.getAllPersonReceviers();

    this.noteForm.patchValue({
      categoryId: data.categoryId,
      description: data.description,
      personRecevierId: data.personRecevierId,
      // personSenderId: data.personSenderId,
      createdAt: new Date(data.createdAt ?? this.date)
    });
  }

  async onSubmit() {
    if (this.noteForm.invalid) {
      return;
    }

    this.loading = true;

    // ✅ Gönderilecek veri objesi
    let noteData = {};

    try {

      if (this.id != null) {
        if (this.authService.isEndpointStatus('PUT.Updateing.UpdateNote')) {
          noteData = {
            id: this.id,
            categoryId: this.noteForm.value.categoryId,
            description: this.noteForm.value.description,
            personRecevierId: this.noteForm.value.personRecevierId,
            personSenderId: (_isPersonId > 0 || _isPersonId != null) ? _isPersonId : null,
            createdAt: new Date(this.noteForm.value.createdAt),
            isPinned: false,
            isPrivate: false
          };
          const result = await this.noteService.updateNote(noteData);
          if (result.status === true) {
            this.toastrService.success(result.message);
            this.activeModal.close(true);
          } else {
            this.toastrService.error(result.message);
          }
        }
      }
      else {
        if (this.authService.isEndpointStatus('POST.Writing.CreateNote')) {
          noteData = {
            categoryId: this.noteForm.value.categoryId,
            description: this.noteForm.value.description,
            personRecevierId: this.noteForm.value.personRecevierId,
            personSenderId: (_isPersonId > 0 || _isPersonId != null) ? _isPersonId : null,
            createdAt: new Date(this.noteForm.value.createdAt),
            isPinned: false,
            isPrivate: false
          }
          const result = await this.noteService.createNote(noteData);
          if (result.status === true) {
            this.toastrService.success(result.message);
            this.activeModal.close(true);
          } else {
            this.toastrService.error(result.message);
          }
        }
      }

    } catch (error) {
      console.error('Not oluşturulurken hata:', error);
    } finally {
      this.loading = false;
    }

  }

  closeModal(result: boolean = false) {
    this.activeModal.close(result);
  }


  async showCreateCategoryDialog() {
    const modal = this.modalService.open(CreateCategoryDialogComponent, {
      size: 'sm',
      centered: true,
      backdrop: 'static'
    });
    modal.componentInstance.data = { kindId: 3022 };
    modal.result.then(async (result) => {
      if (result) {
        await this.getAllCategories();
      }
    })
  }
}
